import { useSelector } from 'react-redux';
import { selectCartId } from '../../App/selectors';
import type { Identifier } from '@ticketmaster/tm1pos-web-shared/model/identifier';

export const useLegacyCartId = (): Identifier | undefined => {
  const rawCartId: string | undefined = useSelector(selectCartId);

  if (rawCartId) {
    const [system, id] = rawCartId.split('-');
    return { system, id };
  }
  return undefined;
};
